import React from 'react';
import { useLocation } from 'react-router-dom';

import useAuth from '@giro/shared-hooks/useAuth.hook';
import getApiClientsService from '@giro/shared-services/pdv/getApiClients.service';
import ROUTES from '@giro-pdv/constants/routes.constant';
import { hasGtappAccess } from '@giro-pdv/modules/terminals/terminals.types';

export default function useGtappMenuAccess(
  client?: { gtapp?: unknown } | null
) {
  const { signedIn, token } = useAuth();
  const { pathname } = useLocation();
  const usesLoadedClient = [ROUTES.PDV.ROOT, ROUTES.TERMINALS.ROOT].some(
    (root) => pathname === root || pathname.startsWith(`${root}/`)
  );
  const [access, setAccess] = React.useState<{
    token: string;
    enabled: boolean;
  } | null>(null);

  React.useEffect(() => {
    if (!signedIn || !token || usesLoadedClient) return undefined;
    let active = true;
    // Read only the menu entitlement here. Dispatching the PDV client saga
    // would also initialize the pinpad and payment session.
    getApiClientsService()
      .then(([success, profile]) => {
        if (active) {
          setAccess({
            token,
            enabled: Boolean(success) && hasGtappAccess(profile),
          });
        }
      })
      .catch(() => {
        if (active) setAccess({ token, enabled: false });
      });
    return () => {
      active = false;
    };
  }, [signedIn, token, usesLoadedClient]);

  if (!signedIn || !token) return false;
  return usesLoadedClient
    ? hasGtappAccess(client)
    : access?.token === token && access.enabled;
}
